module.exports = __webpack_public_path__ + "fonts/d175346740b9e28b545f12b18c442317.svg";